import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "../store/store";
import type { ReactNode } from "react";
import { AUTH_STORAGE_TOKEN_KEY, AUTH_STORAGE_USER_KEY, getAuthToken, initializeAuthState } from "@utils/auth";
import { useEffect } from "react";
import { subscribeLogoutFromOtherTabs } from "@utils/authCrossTabBroadcast";
import { logoutSessionInStore } from "@utils/logoutSessionInStore";

interface ReduxProviderProps {
	children: ReactNode;
}

export const ReduxProvider = ({ children }: ReduxProviderProps) => {
	// Hydrate auth before paint so faculty institute seeding is available on first page render.
	useEffect(() => {
		initializeAuthState();

		const unsubBroadcast = subscribeLogoutFromOtherTabs(() => {
			logoutSessionInStore();
		});

		const onStorage = (e: StorageEvent) => {
			if (e.storageArea !== localStorage) return;
			if (e.key !== AUTH_STORAGE_TOKEN_KEY && e.key !== AUTH_STORAGE_USER_KEY) return;
			if (!getAuthToken()) {
				logoutSessionInStore();
			} else {
				initializeAuthState();
			}
		};
		window.addEventListener("storage", onStorage);

		return () => {
			unsubBroadcast();
			window.removeEventListener("storage", onStorage);
		};
	}, []);

	return (
		<Provider store={store}>
			<PersistGate
				loading={null}
				persistor={persistor}
				onBeforeLift={() => {
					initializeAuthState();
				}}
			>
				{children}
			</PersistGate>
		</Provider>
	);
};
